/**
 * Flattens the API's per-field validation error arrays into a plain object of
 * single string messages.  Suitable for setting directly into existing
 * `{ fieldName: '' }` error state used across modals and forms.
 *
 * Input:  { name: ["The name field is required.", "..."], amount: ["Must be ≥ 0"] }
 * Output: { name: "The name field is required.", amount: "Must be ≥ 0" }
 */
export const normalizeFieldErrors = (errors) => {
    if (!errors || typeof errors !== 'object') return {};
    return Object.fromEntries(
        Object.entries(errors).map(([field, messages]) => [
            field,
            Array.isArray(messages) ? messages[0] : messages,
        ])
    );
};
